import { render, staticRenderFns } from "./chat-item.vue?vue&type=template&id=4ccfc0dd&scoped=true&"
import script from "./chat-item.vue?vue&type=script&lang=js&"
export * from "./chat-item.vue?vue&type=script&lang=js&"
import style0 from "./chat-item.vue?vue&type=style&index=0&id=4ccfc0dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccfc0dd",
  null
  
)

export default component.exports